/* Utils för att koppla ihop kartstödet med FSOK.
highLightBeteckning är ett hack för att det ska fungera i IE,
då <button>-element ej fungerar bra i IE/React.
 */

export function highLightBeteckning() {
  setTimeout(function () {
    const b = document.getElementsByClassName(
      'beteckning-container'
    ) as HTMLCollectionOf<HTMLElement>;
    if (b !== null) {
      for (let i = 0; i < b.length; i++) {
        if (i === 0) {
          const firstBet = document.getElementsByClassName(
            'beteckning-container'
          )[i] as HTMLElement;
          firstBet.style.backgroundColor = '#f7f7f7';
        } else {
          const restBet = document.getElementsByClassName(
            'beteckning-container'
          )[i] as HTMLElement;
          restBet.style.backgroundColor = '#fff';
        }
      }
    }
  }, 200);
}

export function setInputFields(beteckning: string) {
  const omnibox = document.getElementById(
    'sokPafastighet:fastighet'
  ) as HTMLInputElement;
  if (omnibox) {
    omnibox.value =
      tvattaKommun(beteckning) + ' ' + tvattaBeteckning(beteckning);
  } else {
    setBeteckningInput(beteckning);
    setKommunInput(beteckning);
  }
}

export function setBeteckningInput(beteckning: string) {
  const b = document.getElementById(
    'sokPafastighet:beteckning'
  ) as HTMLInputElement;
  if (b !== null) {
    b.value = tvattaBeteckning(beteckning);
  }
}

export function setKommunInput(beteckning: string) {
  const k = document.getElementById(
    'sokPafastighet:kommun'
  ) as HTMLInputElement;
  if (k !== null) {
    k.value = tvattaKommun(beteckning);
  }
}

function tvattaKommun(beteckning: string) {
  if (beteckning.startsWith('UPPLANDS VÄSBY')) {
    return beteckning.substring(0, 14);
  }
  return beteckning.split(' ')[0];
}

function tvattaBeteckning(beteckning: string) {
  if (beteckning.startsWith('UPPLANDS VÄSBY')) {
    return beteckning.split('>')[0].substr(beteckning.indexOf(' ') + 7);
  }
  return beteckning.split('>')[0].substr(beteckning.indexOf(' ') + 1);
}
